import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController, LoadingController, ToastController } from '@ionic/angular';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-video',
  templateUrl: './video.page.html',
  styleUrls: ['./video.page.scss'],
})
export class VideoPage implements OnInit {
  loading;
  video;

  is_chrome;
  is_firefox;
  is_safari;

  constructor(
    public navParams: NavParams,
    public modalController: ModalController,
    public loadingController: LoadingController,
    public toastController: ToastController
  ) {
    this.is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    this.is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
    this.is_safari = navigator.userAgent.indexOf("Safari") > -1;
    if ((this.is_chrome)&&(this.is_safari)) { this.is_safari = false; }

    this.video = navParams.get('video');
  }

  ngOnInit() {
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  async presentLoading() {
    this.loading = await this.loadingController.create({
      message: 'Aguarde...'
    });
    await this.loading.present();
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      color: "danger"
    });
    toast.present();
  }

}
